export default __webpack_public_path__ + "static/media/icon-manage-assets.7b4c232d.svg";